__turbopack_context__.v({
  "link": "styles-module-scss-module__jO8M4W__link",
  "link__image": "styles-module-scss-module__jO8M4W__link__image",
  "link__info": "styles-module-scss-module__jO8M4W__link__info",
  "link__item": "styles-module-scss-module__jO8M4W__link__item",
});
